import { withPlugins, eventBus, domEvents } from '@spon/plugins';

import Headroom from 'headroom.js';
import toggle from '@/ui/toggle';
import { Collapse } from 'bootstrap';

function Header({ node, name, plugins: { addEvents } }) {
	if (!node) return;

	const breakpoint = 1024;
	const headerSearch = node.querySelector('.menu-dropdown');
	const primaryNavigation = node.querySelector('#primary-navigation');

	const navPrimaryLinks = [...document.querySelectorAll('[data-nav-primary]')];
	const navDropdowns = [...document.querySelectorAll('.c-header__dropdown')];
	const searchToggle = node.querySelector('[data-search-toggle]');
	const navItems = [...document.querySelectorAll('.c-nav__item')];
	const primaryNavItems = [...document.querySelectorAll('[data-nav-item]')];

	const options = {
		offset: node.clientHeight * 1.25 || 0,
		tolerance: {
			up: 5,
			down: 0,
		},
	};

	function onSearchClick(event) {
		closeDesktopNav();

		event.preventDefault();
		searchToggle.classList.toggle('is-active');
		headerSearch.classList.toggle('is-open');
	}

	function onNavOver(event) {
		if (window.innerWidth < breakpoint) return;

		closeSearch();
		closeDesktopNav();
	}

	function closeDesktopNav() {
		navDropdowns.forEach(dropdown => {
			dropdown.classList.remove('show');
		});

		primaryNavItems.forEach(item => {
			item.classList.remove('is-open');
		});
	}

	function closeSearch() {
		headerSearch.classList.remove('is-open');
		searchToggle.classList.remove('is-active');
	}

	function onNavItemClick(event) {
		if (window.innerWidth > breakpoint) return;

		const { target } = event;

		const targetParent = target.closest(
			'.c-header__primary-nav > .relative.group'
		);

		if (targetParent) {
			if (targetParent.classList.contains('bg-grey-lighter')) {
				targetParent.classList.remove('bg-grey-lighter');
			} else {
				primaryNavItems.forEach(item => {
					item.classList.remove('bg-grey-lighter');
				});
				targetParent.classList.add('bg-grey-lighter');
			}
		}
	}

	let navOpen = false;

	function onBurgerClick(event) {
		closeSearch();

		const { target } = event;

		if (navOpen) {
			navOpen = false;
			document.documentElement.classList.remove('nav-open');
			target.classList.remove('is-active');
			node.classList.remove('is-open');
			primaryNavigation.classList.remove('is-open');
		} else {
			navOpen = true;
			document.documentElement.classList.add('nav-open');
			target.classList.add('is-active');
			node.classList.add('is-open');
			primaryNavigation.classList.add('is-open');
		}
	}

	addEvents({
		'click [data-search-toggle]': onSearchClick,
		'click [data-menu-toggle]': onBurgerClick,
		'mouseover [data-nav-primary]': onNavOver,
		'click [data-nav-item]': onNavItemClick,
	});
}

export default withPlugins(domEvents)(Header);
